import { FC } from 'react';

import { BreadCrumbsProvider } from '../../hooks/contexts/breadCrumb.context';
import { CartProvider } from '../../hooks/contexts/cart.context';
import { ComboProgressProvider } from '../../hooks/contexts/comboProgress.context';
import { EventProvider } from '../../hooks/contexts/event.context';
import { ModalProvider } from '../../hooks/contexts/modal.context';
import { UiProvider } from '../../hooks/contexts/ui.context';
import Details from '../EventDetails/details';
import AppBar from '../Header/AppBar';
import FixedBarTheme from '../Header/AppBar/FixedBarTheme';
import LayoutContent from './content';
import * as Style from './layout.styles';

const Layout: FC = () => {

  return (
    <EventProvider>
      <ModalProvider>
        <UiProvider>
          <BreadCrumbsProvider>
            <CartProvider>
              <ComboProgressProvider>
                <Style.Layout id="layout-app" data-testid="layout-app">
                  <Style.Header id="header-app" data-testid="header-app">
                    <FixedBarTheme />
                    <Style.Container>
                      <AppBar />
                      <Details />
                    </Style.Container>
                  </Style.Header>
                  <LayoutContent />
                </Style.Layout>
              </ComboProgressProvider>
            </CartProvider>
          </BreadCrumbsProvider>
        </UiProvider>
      </ModalProvider>
    </EventProvider>
  );
};

export default Layout;
